import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CoreComponentsModule } from './components/core-components.module';

@NgModule({
  imports: [
    CoreComponentsModule
  ],
  exports: [
    CoreComponentsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule { }
